export const columns = [
	{
		id: 'id',
		label: 'Id',
		hidden: true,
	},
	{
		id: 'name',
		label: 'Nombre',
	},
	{
		id: 'branchOffice',
		label: 'Sucursal',
	},
	{
		id: 'status',
		label: `Estatus`,
	},
	{
		id: 'userStatus',
		label: 'Activar/Desactivar',
		removeOrdenation: true,
	},
	{
		id: 'edit',
		label: '',
		removeOrdenation: true,
	},
];
